import React from 'react';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Autoplay } from 'swiper/modules';
import 'swiper/css';
import PrincipleCard from './PrincipleCard';

const principlesData = [
  {
    text: "Everyone has something to offer and something to learn.",
    icon: "fa-hand-holding-heart"
  },
  {
    text: "Ideas are more powerful when shared and executed together.",
    icon: "fa-lightbulb"
  },
  {
    text: "Mentorship is a cycle; today’s learners are tomorrow’s leaders.",
    icon: "fa-user-friends"
  },
  {
    text: "Creativity is a force for change—social, cultural, and economic.",
    icon: "fa-palette"
  },
  {
    text: "The creative journey is not a competition; it’s a community.",
    icon: "fa-users"
  }
];

const PrinciplesCarousel = () => {
  const sliderOptions = {
    spaceBetween: 30,
    slidesPerView: 4,
    loop: true,
    autoplay: {
      delay: 5000,
      disableOnInteraction: false,
    },
    breakpoints: {
      0: {
        spaceBetween: 20,
        slidesPerView: 1,
      },
      575: {
        spaceBetween: 20,
        slidesPerView: 2,
      },
      991: {
        spaceBetween: 30,
        slidesPerView: 3,
      },
      1199: {
        spaceBetween: 30,
        slidesPerView: 4,
      },
    },
  };

  return (
    <section className="brand-one brand-two" style={{ padding: '20px 0', backgroundColor: '#f9f9f9' }}>
      <div className="container">
        <div className="section-title text-center">
          <span className="section-title__tagline" style={{ color: '#c70a26', fontWeight: 'bold', textTransform: 'uppercase', letterSpacing: '2px' }}>What we believe</span>
          <h2 className="section-title__title" style={{ color: '#33215d', fontSize: '36px', margin: '10px 0 10px' }}>Our Guiding Principles</h2>
          <p className="section-title__text" style={{ maxWidth: '700px', margin: '0 auto 30px', color: '#666' }}>
            At C2, we believe in the power of community, creativity, and collaboration. These principles guide our mission to empower creatives across Africa and the world.
          </p>
        </div>
        <div className="brand-two__inner">
          <Swiper {...sliderOptions} modules={[Autoplay]} className="thm-swiper__slider swiper-container" style={{ padding: '10px' }}>
            {principlesData.map((principle, index) => (
              <SwiperSlide key={index} style={{ height: 'auto' }}>
                <PrincipleCard
                  text={principle.text}
                  icon={principle.icon}
                />
              </SwiperSlide>
            ))}
          </Swiper>
        </div>
      </div>
    </section>
  );
};

export default PrinciplesCarousel;
